export default __webpack_public_path__ + "static/media/play.56b630ac.png";